document.addEventListener('DOMContentLoaded', function () {
  var quoteRoot = document.querySelector('[data-fomu-quote-key]');
  var quoteKey = quoteRoot ? quoteRoot.getAttribute('data-fomu-quote-key') : '';

  function loadFomuQuote() {
    if (!quoteKey) return { items: [] };
    try {
      var saved = JSON.parse(window.localStorage.getItem(quoteKey));
      if (!saved || !Array.isArray(saved.items)) return { items: [] };
      saved.items = saved.items.filter(function (item) {
        return item && item.variantId && item.productTitle;
      });
      return saved;
    } catch (error) {
      return { items: [] };
    }
  }

  function saveFomuQuote(quote) {
    if (!quoteKey) return;
    quote.updatedAt = new Date().toISOString();
    window.localStorage.setItem(quoteKey, JSON.stringify(quote));
    updateFomuQuoteCounts(quote);
  }

  function quoteItemCount(quote) {
    return quote.items.reduce(function (total, item) {
      return total + Math.max(1, parseInt(item.quantity, 10) || 1);
    }, 0);
  }

  function updateFomuQuoteCounts(quote) {
    var count = quoteItemCount(quote || loadFomuQuote());
    document.querySelectorAll('[data-fomu-quote-count]').forEach(function (element) {
      element.textContent = String(count);
    });
  }

  function formatQuoteMoney(cents, currency) {
    var code = currency || 'AUD';
    try {
      return new Intl.NumberFormat('en-AU', {
        style: 'currency',
        currency: code,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100) + ' ' + code;
    } catch (error) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2) + ' ' + code;
    }
  }

  updateFomuQuoteCounts();

  var newsletterModal = document.querySelector('[data-newsletter-modal]');
  if (newsletterModal) {
    var newsletterDialog = newsletterModal.querySelector('[data-newsletter-dialog]');
    var newsletterEmail = newsletterModal.querySelector('[data-newsletter-email]');
    var newsletterOpeners = Array.prototype.slice.call(document.querySelectorAll('[data-newsletter-open]'));
    var newsletterClosers = Array.prototype.slice.call(newsletterModal.querySelectorAll('[data-newsletter-close]'));
    var newsletterLastFocus = null;

    function newsletterFocusable() {
      return Array.prototype.slice.call(newsletterDialog.querySelectorAll('button:not([disabled]), input:not([disabled]), [href], [tabindex]:not([tabindex="-1"])'));
    }

    function openNewsletter() {
      newsletterLastFocus = document.activeElement;
      newsletterModal.hidden = false;
      document.body.classList.add('fomu-newsletter-is-open');
      window.setTimeout(function () {
        if (newsletterEmail) newsletterEmail.focus();
        else if (newsletterDialog) newsletterDialog.focus();
      }, 0);
    }

    function closeNewsletter() {
      newsletterModal.hidden = true;
      document.body.classList.remove('fomu-newsletter-is-open');
      if (newsletterLastFocus && typeof newsletterLastFocus.focus === 'function') newsletterLastFocus.focus();
    }

    newsletterOpeners.forEach(function (opener) {
      opener.addEventListener('click', openNewsletter);
    });
    newsletterClosers.forEach(function (closer) {
      closer.addEventListener('click', closeNewsletter);
    });
    document.addEventListener('keydown', function (event) {
      if (newsletterModal.hidden) return;
      if (event.key === 'Escape') {
        closeNewsletter();
        return;
      }
      if (event.key !== 'Tab') return;
      var focusable = newsletterFocusable();
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (newsletterModal.querySelector('[data-newsletter-message]')) openNewsletter();
  }

  function splitOptionValue(value) {
    var text = String(value || '').trim();
    var match = text.match(/^(.+?)\s+(?:-|–|—)\s+(.+)$/);
    if (!match) return { family: text, detail: text, compound: false };
    return { family: match[1].trim(), detail: match[2].trim(), compound: true };
  }

  function optionHeadings(text) {
    var title = String(text || '').replace(/:\s*$/, '').trim();
    var joined = title.match(/^(.+?)\s+(?:and|&)\s+(.+)$/i);
    if (joined) return { family: joined[1].trim(), detail: joined[2].trim() };
    var ending = title.match(/^(.+?)\s+(Color|Colour|Finish)$/i);
    if (ending) return { family: ending[1].trim(), detail: ending[2].trim() };
    return { family: title || 'Type', detail: 'Option' };
  }

  function isComValue(value) {
    return /^(?:COM|Customer(?:'|’)?s Own Material)$/i.test(String(value || '').trim());
  }

  function familyDisplayName(family) {
    return isComValue(family) ? "Customer's Own Material (COM)" : family;
  }

  function updateComDetails(form) {
    var panel = form.querySelector('[data-com-details]');
    var input = panel && panel.querySelector('[data-com-input]');
    if (!panel || !input) return;
    var selectedCom = Array.prototype.slice.call(form.querySelectorAll('[data-product-option]:checked')).some(function (option) {
      return isComValue(option.value);
    });
    panel.hidden = !selectedCom;
    input.disabled = !selectedCom;
    input.required = selectedCom;
  }

  function enhanceGroupedOption(fieldset) {
    if (!fieldset || fieldset.hasAttribute('data-grouped-option')) return;
    var legend = fieldset.querySelector('legend');
    var labels = Array.prototype.slice.call(fieldset.querySelectorAll('label'));
    var items = labels.map(function (label) {
      var input = label.querySelector('[data-product-option]');
      var span = label.querySelector('span');
      if (!input || !span) return null;
      var parts = splitOptionValue(input.value);
      return { label: label, input: input, span: span, family: parts.family, detail: parts.detail, compound: parts.compound };
    }).filter(Boolean);
    var hasCompoundValue = items.some(function (item) { return item.compound; });
    var families = [];
    items.forEach(function (item) {
      if (families.indexOf(item.family) === -1) families.push(item.family);
    });
    if (!legend || !hasCompoundValue || families.length < 2) return;

    fieldset.setAttribute('data-grouped-option', '');
    var headings = optionHeadings(legend.textContent);
    legend.textContent = headings.family + ':';

    var familyList = document.createElement('div');
    familyList.className = 'fomu-product-option__families';
    var detailTitle = document.createElement('p');
    detailTitle.className = 'fomu-product-option__value-title';
    detailTitle.textContent = headings.detail + ':';

    items.forEach(function (item) {
      item.label.setAttribute('data-option-family', item.family);
      item.span.textContent = item.detail;
    });

    function selectFamily(family, selectFirstValue) {
      var selectedCom = isComValue(family);
      Array.prototype.slice.call(familyList.querySelectorAll('[data-option-family-button]')).forEach(function (button) {
        var selected = button.getAttribute('data-option-family-button') === family;
        button.classList.toggle('is-selected', selected);
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      items.forEach(function (item) {
        item.label.hidden = item.family !== family || selectedCom;
      });
      detailTitle.hidden = selectedCom;
      var checked = items.find(function (item) { return item.input.checked; });
      if (selectFirstValue && (!checked || checked.family !== family)) {
        var first = items.find(function (item) { return item.family === family && !item.input.disabled; });
        if (first) {
          first.input.checked = true;
          first.input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }

    families.forEach(function (family) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'fomu-product-option__family';
      button.setAttribute('data-option-family-button', family);
      button.setAttribute('aria-pressed', 'false');
      button.textContent = familyDisplayName(family);
      button.addEventListener('click', function () { selectFamily(family, true); });
      familyList.appendChild(button);
    });

    var firstLabel = labels[0];
    fieldset.insertBefore(familyList, firstLabel);
    fieldset.insertBefore(detailTitle, firstLabel);
    var initiallyChecked = items.find(function (item) { return item.input.checked; });
    selectFamily(initiallyChecked ? initiallyChecked.family : families[0], false);
  }

  document.querySelectorAll('[data-fomu-gallery]').forEach(function (gallery) {
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.fomu-gallery__slide'));
    if (slides.length < 2) return;
    var current = 0;
    window.setInterval(function () {
      slides[current].classList.remove('is-current');
      current = (current + 1) % slides.length;
      slides[current].classList.add('is-current');
    }, 4500);
  });

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var current = 0;
    var counter = gallery.querySelector('[data-gallery-current]');
    function show(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length;
      track.style.transform = 'translate3d(' + (-current * 100) + '%,0,0)';
      if (counter) counter.textContent = String(current + 1);
    }
    gallery.fomuShowSlide = show;
    gallery.fomuShowVariantMedia = function (mediaId, imageId) {
      var mediaKey = mediaId == null ? '' : String(mediaId);
      var imageKey = imageId == null ? '' : String(imageId);
      var target = slides.findIndex(function (slide) {
        return (mediaKey && slide.getAttribute('data-media-id') === mediaKey) ||
          (imageKey && slide.getAttribute('data-image-id') === imageKey);
      });
      if (target > -1) show(target);
    };
    var previous = gallery.querySelector('[data-gallery-previous]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (previous) previous.addEventListener('click', function () { show(current - 1); });
    if (next) next.addEventListener('click', function () { show(current + 1); });
  });

  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.querySelectorAll('.fomu-product-option').forEach(enhanceGroupedOption);
    updateComDetails(form);
    var json = form.querySelector('[data-product-variants]');
    var variantInput = form.querySelector('[data-variant-id]');
    var total = form.querySelector('[data-product-total]');
    var tradeTotal = form.querySelector('[data-product-trade-total]');
    var add = form.querySelector('[data-product-add]');
    var addToQuote = form.querySelector('[data-fomu-add-to-quote]');
    var quoteFeedback = form.querySelector('[data-fomu-quote-feedback]');
    if (!json || !variantInput || !add) return;
    var variants;
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }
    var currentVariant = null;
    var productRoot = form.closest('[data-fomu-product]');
    var summaryTradeTotal = productRoot ? productRoot.querySelector('[data-product-summary-trade]') : null;
    var variantGallery = productRoot ? productRoot.querySelector('[data-product-gallery]') : null;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'AUD';
    function update() {
      var selected = Array.prototype.slice.call(form.querySelectorAll('[data-product-option]:checked')).map(function (input) { return input.value; });
      var variant = variants.find(function (item) {
        return !selected.length || item.options.every(function (value, index) { return value === selected[index]; });
      });
      if (!variant) {
        currentVariant = null;
        add.disabled = true;
        add.textContent = 'UNAVAILABLE';
        if (addToQuote) {
          addToQuote.disabled = true;
          addToQuote.textContent = 'UNAVAILABLE';
        }
        return;
      }
      currentVariant = variant;
      variantInput.value = variant.id;
      add.disabled = !variant.available;
      add.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      if (addToQuote) {
        addToQuote.disabled = !variant.available;
        addToQuote.textContent = variant.available ? 'ADD TO QUOTE' : 'SOLD OUT';
      }
      var symbols = { AUD: '$', USD: '$', NZD: '$', EUR: '€', GBP: '£' };
      var amount = new Intl.NumberFormat('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(variant.price / 100);
      var tradeAmount = new Intl.NumberFormat('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Math.round(variant.price * 0.9) / 100);
      if (total) total.textContent = 'TOTAL ' + (symbols[currency] || '') + amount + ' ' + currency;
      if (tradeTotal) tradeTotal.textContent = 'TRADE ' + (symbols[currency] || '') + tradeAmount + ' ' + currency;
      if (summaryTradeTotal) summaryTradeTotal.textContent = 'TRADE ' + (symbols[currency] || '') + tradeAmount + ' ' + currency;
      if (variantGallery && typeof variantGallery.fomuShowVariantMedia === 'function') {
        var mediaId = variant.featured_media_id || (variant.featured_media && variant.featured_media.id);
        var imageId = variant.featured_image_id || (variant.featured_image && variant.featured_image.id);
        if (mediaId || imageId) variantGallery.fomuShowVariantMedia(mediaId, imageId);
      }
    }
    form.addEventListener('change', function () {
      update();
      updateComDetails(form);
      if (quoteFeedback) quoteFeedback.textContent = '';
    });

    if (addToQuote) {
      addToQuote.addEventListener('click', function () {
        if (!currentVariant || !quoteKey) return;
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }

        var comInput = form.querySelector('[data-com-input]:not([disabled])');
        var comDetails = comInput ? comInput.value.trim() : '';
        var identity = String(currentVariant.id) + '|' + comDetails.toLowerCase();
        var quote = loadFomuQuote();
        var existing = quote.items.find(function (item) { return item.identity === identity; });

        if (existing) {
          existing.quantity = Math.max(1, parseInt(existing.quantity, 10) || 1) + 1;
        } else {
          quote.items.push({
            identity: identity,
            variantId: String(currentVariant.id),
            productId: String(addToQuote.getAttribute('data-product-id') || ''),
            productTitle: addToQuote.getAttribute('data-product-title') || '',
            productUrl: addToQuote.getAttribute('data-product-url') || '',
            productImage: currentVariant.image_url || addToQuote.getAttribute('data-product-image') || '',
            variantTitle: currentVariant.title === 'Default Title' ? '' : currentVariant.title,
            options: currentVariant.options || [],
            comDetails: comDetails,
            rrp: Number(currentVariant.price) || 0,
            tradePrice: Math.round((Number(currentVariant.price) || 0) * 0.9),
            currency: currency,
            quantity: 1
          });
        }

        saveFomuQuote(quote);
        if (quoteFeedback) quoteFeedback.textContent = 'ADDED TO QUOTE';
        addToQuote.textContent = 'ADDED TO QUOTE';
        window.setTimeout(function () {
          if (currentVariant && currentVariant.available) addToQuote.textContent = 'ADD TO QUOTE';
        }, 1600);
      });
    }
    update();
  });

  var quotePage = document.querySelector('[data-fomu-quote-page]');
  if (quotePage && quoteKey) {
    var quoteItems = quotePage.querySelector('[data-fomu-quote-items]');
    var quoteTemplate = quotePage.querySelector('[data-fomu-quote-item-template]');
    var quoteEmpty = quotePage.querySelector('[data-fomu-quote-empty]');
    var quoteSummary = quotePage.querySelector('[data-fomu-quote-summary]');
    var quoteTradeTotal = quotePage.querySelector('[data-fomu-quote-trade-total]');
    var quoteDates = quotePage.querySelectorAll('[data-fomu-quote-date]');
    var quoteCurrency = quotePage.getAttribute('data-currency') || 'AUD';
    var quoteCustomerEmail = (quotePage.getAttribute('data-customer-email') || '').trim().toLowerCase();
    var quoteDetailFields = quotePage.querySelectorAll('[data-fomu-quote-detail]');

    function resizeQuoteTextarea(field) {
      if (!field || field.tagName !== 'TEXTAREA') return;
      field.style.height = 'auto';
      field.style.height = Math.max(52, field.scrollHeight) + 'px';
    }

    if (quoteDetailFields.length) {
      var quoteWithDetails = loadFomuQuote();
      quoteWithDetails.details = quoteWithDetails.details || {};
      if (quoteCustomerEmail) {
        try {
          var applicantDetails = JSON.parse(window.localStorage.getItem('fomuTradeApplicant-' + quoteCustomerEmail));
          if (applicantDetails) {
            if (!quoteWithDetails.details.name && applicantDetails.name) quoteWithDetails.details.name = applicantDetails.name;
            if (!quoteWithDetails.details.businessName && applicantDetails.businessName) quoteWithDetails.details.businessName = applicantDetails.businessName;
          }
        } catch (error) {
          // Continue with Shopify customer details if no saved application is available.
        }
      }
      quoteDetailFields.forEach(function (field) {
        var detailKey = field.getAttribute('data-fomu-quote-detail');
        if (Object.prototype.hasOwnProperty.call(quoteWithDetails.details, detailKey)) {
          field.value = quoteWithDetails.details[detailKey] || '';
        } else if (field.value) {
          quoteWithDetails.details[detailKey] = field.value;
        }
        resizeQuoteTextarea(field);
        field.addEventListener('input', function () {
          var currentQuote = loadFomuQuote();
          currentQuote.details = currentQuote.details || {};
          currentQuote.details[detailKey] = field.value;
          saveFomuQuote(currentQuote);
          resizeQuoteTextarea(field);
        });
      });

      var preparedName = quoteWithDetails.details.name || '';
      if (preparedName) {
        quotePage.querySelectorAll('[data-fomu-prepared-name]').forEach(function (element) {
          element.textContent = preparedName;
        });
      }
      var preparedBusiness = quoteWithDetails.details.businessName || '';
      if (preparedBusiness) {
        quotePage.querySelectorAll('[data-fomu-prepared-business]').forEach(function (element) {
          element.textContent = preparedBusiness;
          element.hidden = false;
        });
      }
      saveFomuQuote(quoteWithDetails);
    }

    if (quoteDates.length) {
      var formattedQuoteDate = new Intl.DateTimeFormat('en-AU', {
        day: '2-digit', month: 'long', year: 'numeric'
      }).format(new Date());
      quoteDates.forEach(function (quoteDate) {
        quoteDate.textContent = formattedQuoteDate;
      });
    }

    function renderFomuQuote() {
      var quote = loadFomuQuote();
      quoteItems.innerHTML = '';
      var hasItems = quote.items.length > 0;
      quoteEmpty.hidden = hasItems;
      quoteSummary.hidden = !hasItems;
      var tradeTotalValue = 0;

      quote.items.forEach(function (item) {
        var fragment = quoteTemplate.content.cloneNode(true);
        var article = fragment.querySelector('.fomu-quote-item');
        var links = fragment.querySelectorAll('[data-fomu-quote-item-link]');
        var image = fragment.querySelector('[data-fomu-quote-item-image]');
        var title = fragment.querySelector('[data-fomu-quote-item-title]');
        var variant = fragment.querySelector('[data-fomu-quote-item-variant]');
        var com = fragment.querySelector('[data-fomu-quote-item-com]');
        var trade = fragment.querySelector('[data-fomu-quote-item-trade]');
        var quantity = fragment.querySelector('[data-fomu-quote-quantity]');
        var lineTotal = fragment.querySelector('[data-fomu-quote-item-line-total]');
        var remove = fragment.querySelector('[data-fomu-quote-remove]');
        var itemQuantity = Math.max(1, parseInt(item.quantity, 10) || 1);
        var currency = item.currency || quoteCurrency;

        links.forEach(function (link) { link.setAttribute('href', item.productUrl || '#'); });
        title.textContent = item.productTitle;
        image.src = item.productImage || '';
        image.alt = item.productTitle;
        if (!item.productImage) image.hidden = true;
        variant.textContent = item.options && item.options.length ? item.options.join(' / ') : (item.variantTitle || 'Made to order');
        if (item.comDetails) {
          com.hidden = false;
          com.textContent = "CUSTOMER'S OWN MATERIAL: " + item.comDetails;
        }
        trade.textContent = formatQuoteMoney(item.tradePrice, currency);
        quantity.value = String(itemQuantity);
        lineTotal.textContent = formatQuoteMoney(item.tradePrice * itemQuantity, currency);
        tradeTotalValue += item.tradePrice * itemQuantity;

        quantity.addEventListener('change', function () {
          item.quantity = Math.max(1, parseInt(quantity.value, 10) || 1);
          saveFomuQuote(quote);
          renderFomuQuote();
        });

        remove.addEventListener('click', function () {
          quote.items = quote.items.filter(function (savedItem) { return savedItem.identity !== item.identity; });
          saveFomuQuote(quote);
          renderFomuQuote();
        });

        article.setAttribute('data-quote-identity', item.identity);
        quoteItems.appendChild(fragment);
      });

      quoteTradeTotal.textContent = formatQuoteMoney(tradeTotalValue, quoteCurrency);
      updateFomuQuoteCounts(quote);
    }

    var printButton = quotePage.querySelector('[data-fomu-quote-print]');
    if (printButton) {
      printButton.addEventListener('click', function () {
        var originalTitle = document.title;
        var fileDate = new Date().toISOString().slice(0, 10);
        document.title = 'Fomu Trade Quotation ' + fileDate;
        window.print();
        window.setTimeout(function () { document.title = originalTitle; }, 500);
      });
    }

    var clearButton = quotePage.querySelector('[data-fomu-quote-clear]');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        if (!window.confirm('Remove every item from this quote?')) return;
        var clearedQuote = loadFomuQuote();
        clearedQuote.items = [];
        saveFomuQuote(clearedQuote);
        renderFomuQuote();
      });
    }

    renderFomuQuote();
  }
});
